import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNav from './helpers/SideNavbar';
import Select from 'react-select';
import Swal from 'sweetalert2';
import TimezoneSelect from 'react-timezone-select';
import { Link, useNavigate } from 'react-router-dom';
import { useFeatureLimits } from './FeatureLimits/FeatureLimitsProvider';
import { FEATURE_NAMES } from '../apis/featureLimits';
import PageDisableOverlay from './FeatureLimits/PageDisableOverlay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faChartBar, faLineChart, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
import { getAllActivePlatforms, formatPlatformNamesForButton, formatPlatformNamesForAlert } from '../utils/platformUtils';

const ScheduleForm = ({ onFeatureUsage }) => {
    const { logFeatureUsage, isFreeUser, isSubscriber, checkFeatureAccess, getRemainingLimit } = useFeatureLimits();
    const navigate = useNavigate();
    const [selectedDays, setSelectedDays] = useState([]);
    const [time, setTime] = useState('');
    const [date, setDate] = useState('');
    const [endDate, setEndDate] = useState(''); // New state for end date
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // Loading state for spinner
    const [options, setOptions] = useState([]); // State for dropdown options
    const [selectedValues, setSelectedValues] = useState([]);
    const [selectedTimezone, setSelectedTimezone] = useState({}); // New state for timezone
	const [showAddPromptModal, setShowAddPromptModal] = useState(false);
	const [newPromptText, setNewPromptText] = useState('');
	const [savingPrompt, setSavingPrompt] = useState(false);
	const [enabledPlatforms, setEnabledPlatforms] = useState([]);
	const [platformsLoading, setPlatformsLoading] = useState(true);
	const [selectedPlatforms, setSelectedPlatforms] = useState([]); // Array of platform codes: ['linkedin', 'facebook', 'instagram']

    /**
     * Map day name to day index (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
     */
    const mapDayToNumber = (day) => {
        const days = {
            'sunday': 0,
            'monday': 1,
            'tuesday': 2,
            'wednesday': 3,
            'thursday': 4,
            'friday': 5,
            'saturday': 6
        };
        return days[day.trim().toLowerCase()];
    };

    /**
     * Count the number of occurrences of selected days between start and end dates
     * Only counts occurrences where the scheduled time is in the future
     * @param {string} startDate - Start date string (YYYY-MM-DD)
     * @param {string} endDate - End date string (YYYY-MM-DD)
     * @param {string|object} selectedDays - Selected days (can be 'Everyday' or a day name)
     * @param {string} scheduleTime - Scheduled time string (HH:mm format)
     * @param {string|object} timezone - Timezone string or object
     * @returns {number} - Number of occurrences
     */
    const countScheduleOccurrences = (startDate, endDate, selectedDays, scheduleTime, timezone) => {
        try {
            if (!startDate || !endDate || !selectedDays || !scheduleTime) {
                return 1; // Fallback to 1 if inputs are missing
            }

            // Expand 'Everyday' into all weekdays
            const daysString = selectedDays?.value === 'Everyday'
                ? 'Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday'
                : selectedDays.value || selectedDays;

            // Split the days string into an array
            const daysArray = daysString.split(',').map(day => day.trim());
            
            // Map day names to day indexes
            const targetDayIndexes = daysArray.map(day => mapDayToNumber(day)).filter(index => index !== undefined);

            if (targetDayIndexes.length === 0) {
                return 1; // Fallback if no valid days
            }

            // Parse dates
            const start = new Date(startDate + 'T00:00:00'); // Set to start of day
            const end = new Date(endDate + 'T23:59:59'); // Set to end of day
            
            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return 1; // Fallback if dates are invalid
            }

            // Get current time
            const now = new Date();

            // Parse schedule time (HH:mm format)
            const [hours, minutes] = scheduleTime.split(':').map(Number);
            if (isNaN(hours) || isNaN(minutes)) {
                return 1; // Fallback if time is invalid
            }

            // Count occurrences that are in the future
            let count = 0;
            const currentDate = new Date(start);
            
            while (currentDate <= end) {
                const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                
                // Check if this day matches one of the selected days
                if (targetDayIndexes.includes(dayOfWeek)) {
                    // Create a datetime for this occurrence
                    const occurrenceDateTime = new Date(currentDate);
                    occurrenceDateTime.setHours(hours, minutes, 0, 0);
                    
                    // Only count if the scheduled time is in the future
                    if (occurrenceDateTime > now) {
                        count++;
                    }
                }
                
                currentDate.setDate(currentDate.getDate() + 1); // Move to next day
            }

            return count > 0 ? count : 1; // Return at least 1
        } catch (error) {
            console.error('Error counting schedule occurrences:', error);
            return 1; // Fallback to 1 if calculation fails
        }
    };

    const UserID = localStorage.getItem("UserID")
    const accessToken = localStorage.getItem('AccessToken');
    const tokenID = localStorage.getItem('Tokenid');
    const RoleID = localStorage.getItem('RoleID');
    const SelectedUserEmail = localStorage.getItem('UserEmail');
    const SelectedUserEmail1 = localStorage.getItem('Email');
    const SelectedUserAccountId = localStorage.getItem('SelectedUserAccountId');
    const AccountType = localStorage.getItem('AccountType');

    const userProfile = JSON.parse(localStorage.getItem("userProfile")) || [];


    const AccountId = userProfile ? userProfile[0]?.AccountId : null;
    const LinkedinEmail = RoleID == 2 ? SelectedUserEmail1 : SelectedUserEmail

    // const LinkedinEmail = userProfile[0]?.Email  ? userProfile[0]?.Email : SelectedUserEmail1;
    const LinkedinTokenid = userProfile ? userProfile[0]?.Tokenid : null;
    const LinkedinAccessToken = userProfile ? userProfile[0]?.AccessToken : null;

    // Set default timezone to user's timezone on component mount
    useEffect(() => {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Only set if timezone is not already set (empty object or null)
        if (!selectedTimezone || (typeof selectedTimezone === 'object' && Object.keys(selectedTimezone).length === 0)) {
            setSelectedTimezone(userTimezone);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (UserID) {
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getprompts/${UserID}`)
                .then((response) => {
                    console.log("API Response:", response.data);
    
                    // Assuming response.data is an array of prompt objects
                    const fetchedPrompts = response.data;
    
                    // Check if no prompts are available
					if (!fetchedPrompts || fetchedPrompts.length === 0) {
						Swal.fire({
							title: 'No Post Prompts Found',
							html: 'You can add or edit prompts in <b>Profile Hub</b><br/>or add a prompt right here.',
							icon: 'info',
							showDenyButton: true,
							showCancelButton: true,
							confirmButtonText: 'Add Here',
							denyButtonText: 'Go to Profile Hub',
							cancelButtonText: 'Close',
							confirmButtonColor: '#2e3192',
							denyButtonColor: '#6c757d'
						}).then((result) => {
							if (result.isConfirmed) {
								setShowAddPromptModal(true);
							} else if (result.isDenied) {
								navigate('/user-form');
							}
						});
					}
    
                    // Create options for the dropdown
                    const promptOptions = fetchedPrompts?.map((prompt) => ({
                        value: prompt.PromptID, // Assuming PromptData is the field you're fetching
                        label: prompt.PromptData
                    }));
    
                    setOptions(promptOptions); // Update the options state for the dropdown
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching prompts:', error);
                    setLoading(false);
                });
        }
    }, [UserID]);

    // Fetch platforms based on AccountType
    useEffect(() => {
        const fetchPlatforms = async () => {
            setPlatformsLoading(true);
            const storedAccountType = localStorage.getItem('AccountType');
            
            // For User accounts, automatically use LinkedIn only (no UI needed)
            if (storedAccountType === 'User' || storedAccountType === 'user') {
                setSelectedPlatforms(['linkedin']);
                setEnabledPlatforms([{ name: 'LinkedIn', code: 'linkedin' }]);
                setPlatformsLoading(false);
                return;
            }
            
            // For Page accounts, fetch all active platforms and show selection UI
            const platforms = await getAllActivePlatforms();
            setEnabledPlatforms(platforms);
            // Default to all platforms selected
            if (platforms.length > 0) {
                setSelectedPlatforms(platforms.map(p => p.code));
            }
            setPlatformsLoading(false);
        };
        fetchPlatforms();
    }, []);





    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate that at least one platform is selected
        if (!selectedPlatforms || selectedPlatforms.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Platform Selected',
                text: 'Please select at least one platform to schedule to.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#2e3192',
                timer: 2000
            });
            return;
        }
        
        if (!accessToken || !tokenID) {
            setError('Access token or token ID is missing');
            return;
        }
        if (selectedDays.length === 0 || !time || selectedValues.length === 0 || !date || !endDate) {
            setError('Please provide all fields');
            return;
        }
        if (new Date(endDate) <= new Date(date)) {
            setError('End date must be greater than start date');
            return;
        }

        // Handle both string and object formats for timezone
        const timezoneValue = typeof selectedTimezone === 'string' ? selectedTimezone : selectedTimezone?.value;
        
        if (!selectedTimezone || !timezoneValue) {
            setError('Please select a timezone');
            return;
        }

        // No platform settings check - use only selected platforms from UI

        // Check feature access before scheduling
        const accessCheck = await checkFeatureAccess(FEATURE_NAMES.SCHEDULE_DAYS);
        if (!accessCheck.canProceed) {
            setError(`You have reached your limit for scheduling posts. ${accessCheck.error || 'Please try again later.'}`);
            return;
        }

        // Calculate how many posts will be scheduled and check against remaining limit
        const occurrenceCount = countScheduleOccurrences(date, endDate, selectedDays, time, timezoneValue);
        const remainingLimit = getRemainingLimit(FEATURE_NAMES.SCHEDULE_DAYS);
        
        if (occurrenceCount > remainingLimit) {
            setError(`You are trying to schedule ${occurrenceCount} posts, but you only have ${remainingLimit} remaining. Please reduce the date range or number of days to schedule within your limit.`);
            return;
        }

        // Validate that end date does not exceed subscription/trial end date
        if (isFreeUser()) {
            // For free users, check against free trial end date (CreatedDate + 30 days + TrialExtensionDays)
            const createdDateStr = localStorage.getItem('CreatedDate');
            if (createdDateStr) {
                const createdDate = new Date(createdDateStr);
                const trialExtensionDays = userProfile && userProfile[0]?.TrialExtensionDays ? parseInt(userProfile[0].TrialExtensionDays) : 0;
                const freeTrialEndDate = new Date(createdDate);
                freeTrialEndDate.setDate(freeTrialEndDate.getDate() + 30 + trialExtensionDays);
                freeTrialEndDate.setHours(23, 59, 59, 999);
                
                const selectedEndDate = new Date(endDate);
                selectedEndDate.setHours(23, 59, 59, 999);
                
                if (selectedEndDate > freeTrialEndDate) {
                    const formattedTrialEnd = freeTrialEndDate.toLocaleDateString();
                    setError(`End date cannot exceed your free trial end date (${formattedTrialEnd}). Please upgrade to schedule beyond your trial period.`);
                    return;
                }
            }
        } else {
            // For subscribed users, check against subscription end date
            const subscriptionEndDate = localStorage.getItem('subscriptionEndDate');
            if (subscriptionEndDate && subscriptionEndDate !== 'null') {
                const subscriptionEnd = new Date(subscriptionEndDate);
                const selectedEndDate = new Date(endDate);
                
                // Set time to end of day for accurate comparison
                subscriptionEnd.setHours(23, 59, 59, 999);
                selectedEndDate.setHours(23, 59, 59, 999);
                
                if (selectedEndDate > subscriptionEnd) {
                    const formattedSubscriptionEnd = subscriptionEnd.toLocaleDateString();
                    setError(`End date cannot exceed your subscription end date (${formattedSubscriptionEnd}). Please select an earlier end date or renew your subscription.`);
                    return;
                }
            }
        }

        // Expand 'Everyday' into all weekdays for backend compatibility
        const daysString = selectedDays?.value === 'Everyday'
            ? 'Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday'
            : selectedDays.value
        const prompts = selectedValues.value
        
        // Use selected platforms directly
        const platformsToSchedule = selectedPlatforms;
        
        // const daysString = days?.map(day => day.value).join(',');
        //  console.log(daysString)
        //  const selectedprompts = [selectedValues]
        // const prompts = selectedprompts?.map(prompt => encodeURIComponent(prompt.value)).join('|');
        setLoading(true); // Start loading spinner
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/schedule-post`, {
                Days: daysString,
                ScheduleTime: time,
                StartDate: date,
                EndDate: endDate,
                Prompt: prompts,
                AccessToken: RoleID == 1 ? LinkedinAccessToken : accessToken,
                Tokenid: RoleID == 1 ? LinkedinTokenid : tokenID,
                TimeZone: timezoneValue, // Use timezoneValue to handle both string and object formats
                Email: LinkedinEmail == 'null' ? email : LinkedinEmail,
                AccountId: RoleID == 1 || RoleID == 4 ? AccountId : SelectedUserAccountId,
                UserID: UserID,
                Status: 'PENDING',
                PromptType: 1,
                AccountType: AccountType,
                platforms: platformsToSchedule // Send selected platforms array
            });

            setMessage(response.data.message);

            if (response.data.message === 'Post scheduled successfully') {
                // Handle both string and object formats for timezone
                const timezoneValue = typeof selectedTimezone === 'string' ? selectedTimezone : selectedTimezone?.value;
                
                // Calculate number of occurrences for usage logging (only future occurrences)
                const occurrenceCount = countScheduleOccurrences(date, endDate, selectedDays, time, timezoneValue);
                console.log(`📊 Calculated ${occurrenceCount} future occurrences for schedule (StartDate: ${date}, EndDate: ${endDate}, Days: ${selectedDays?.value || selectedDays}, Time: ${time})`);
                
                // Log feature usage for schedule posts with calculated occurrence count
                try {
                    await logFeatureUsage(FEATURE_NAMES.SCHEDULE_DAYS, occurrenceCount, JSON.stringify({
                        scheduleType: 'post_schedule',
                        startDate: date,
                        endDate: endDate,
                        daysCount: selectedDays.length,
                        promptsCount: selectedValues.length,
                        occurrenceCount: occurrenceCount,
                        scheduleTime: time
                    }));
                    console.log(`✅ Feature usage logged successfully with count: ${occurrenceCount}`);
                } catch (usageError) {
                    console.error('Error logging feature usage:', usageError);
                }

                // Build success message based on selected platforms
                const selectedPlatformNames = platformsToSchedule.map(code => {
                    const platform = enabledPlatforms.find(p => p.code === code);
                    return platform ? platform.name : code;
                });
                const successMessage = selectedPlatformNames.length === 1
                    ? `Scheduled successfully to ${selectedPlatformNames[0]}`
                    : selectedPlatformNames.length === 2
                    ? `Scheduled successfully to ${selectedPlatformNames[0]} and ${selectedPlatformNames[1]}`
                    : `Scheduled successfully to ${selectedPlatformNames.slice(0, -1).join(', ')}, and ${selectedPlatformNames[selectedPlatformNames.length - 1]}`;
                
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `${successMessage}. Review and approve your scheduled posts in the Pending Posts section.`,
                    showConfirmButton: false,
                    timer: 3000
                });
                resetForm();

                // 🔄 Refresh feature usage data to show updated limits
                if (window.refreshFeatureUsage) {
                    window.refreshFeatureUsage();
                }
            }
            else if (response.data.message === "No specified days") {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'No specified days between Start date and End date',
                    showConfirmButton: false,
                    timer: 3000
                })
            }

            else {
                const selectedPlatformNames = platformsToSchedule.map(code => {
                    const platform = enabledPlatforms.find(p => p.code === code);
                    return platform ? platform.name : code;
                });
                const errorMessage = selectedPlatformNames.length > 0 
                    ? `Error scheduling to ${selectedPlatformNames.join(' & ')}!`
                    : 'Error scheduling post!';
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
            setError('');
        } catch (error) {
            setError('Failed to schedule the post');
            setMessage('');
        } finally {
            setLoading(false); // Stop loading spinner
        }
    };

    const resetForm = () => {
        setSelectedDays([]);
        setTime('');
        setDate('');
        setEndDate('');
        setEmail('');
        setSelectedValues([]);
        setSelectedTimezone({});
        // Reset to default selected platforms
        if (enabledPlatforms.length > 0) {
            setSelectedPlatforms(enabledPlatforms.map(p => p.code));
        }
    };
    const daysOfWeek = [
        { value: 'Everyday', label: 'Everyday' },
        { value: 'Monday', label: 'Monday' },
        { value: 'Tuesday', label: 'Tuesday' },
        { value: 'Wednesday', label: 'Wednesday' },
        { value: 'Thursday', label: 'Thursday' },
        { value: 'Friday', label: 'Friday' },
        { value: 'Saturday', label: 'Saturday' },
        { value: 'Sunday', label: 'Sunday' }
    ];

    const handleSelectChange = (selectedOptions) => {
        console.log(selectedOptions)
        setSelectedDays(selectedOptions || []);
    };

    const handleSelectCategory = (selectedOptions) => {
        setSelectedValues(selectedOptions);
    };

	const handleSavePrompt = async () => {
		if (!newPromptText || !newPromptText.trim()) {
			Swal.fire({ icon: 'warning', title: 'Please enter a prompt' });
			return;
		}
		try {
			setSavingPrompt(true);
			const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/saveprompts`, {
				UserID: Number(UserID),
				PromptData: newPromptText.trim()
			});
			const newOption = { value: resp.data?.PromptID, label: newPromptText.trim() };
			setOptions(prev => [newOption, ...prev]);
			setSelectedValues(newOption);
			setShowAddPromptModal(false);
			setNewPromptText('');
			Swal.fire({ icon: 'success', title: 'Prompt added' });
		} catch (e) {
			console.error('Failed to save prompt:', e);
			Swal.fire({ icon: 'error', title: 'Failed to save prompt' });
		} finally {
			setSavingPrompt(false);
		}
	};

	const handlePlatformToggle = (platformCode) => {
		if (selectedPlatforms.includes(platformCode)) {
			// Prevent unchecking if it's the last selected platform
			if (selectedPlatforms.length > 1) {
				setSelectedPlatforms(selectedPlatforms.filter(p => p !== platformCode));
			} else {
				Swal.fire({
					icon: 'warning',
					title: 'At Least One Platform Required',
					text: 'Please select at least one platform to schedule to.',
					confirmButtonText: 'OK',
					confirmButtonColor: '#2e3192',
					timer: 2000
				});
			}
		} else {
			setSelectedPlatforms([...selectedPlatforms, platformCode]);
		}
	};

    return (
        // <PageDisableOverlay 
        //     featureName={FEATURE_NAMES.SCHEDULE_DAYS}
        //     customMessage="Free users can schedule posts up to 7 days in advance. Subscribers can schedule up to 1 month in advance."
        // >
        <div>
            <div className="">
                <SideNav>
                    <div className="card shadow-sm p-3 mt-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                        <div className="card-header d-flex justify-content-between align-items-center" style={{ border: 'none', backgroundColor: '#fff', padding: '16px' }}>
                            <div className='d-flex align-items-center'>
                                <Link to={localStorage.getItem('RoleID') == '4' ? '/Pagehome' : (localStorage.getItem('RoleID') == '1' ? '/home' : '/adminhome')}>
                                    <h5 className="welcome-text mb-0" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left', margin: 0 }}>
                                        <i class="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>Schedule Post
                                    </h5>
                                </Link>
                            </div>
                            
                            {/* Navigation Icons */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <button
                                    onClick={() => navigate('/viewallpendingposts')}
                                    title="View Pending Posts"
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        color: '#2e3192',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f3f2ef';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '20px' }} />
                                    <span style={{ fontSize: '11px', fontWeight: '500' }}>Pending</span>
                                </button>
                                
                                <button
                                    onClick={() => navigate('/viewallapprovedposts')}
                                    title="View Approved Posts"
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        color: '#2e3192',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f3f2ef';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <FontAwesomeIcon icon={faChartBar} style={{ fontSize: '20px' }} />
                                    <span style={{ fontSize: '11px', fontWeight: '500' }}>Approved</span>
                                </button>
                                
                                <button
                                    onClick={() => navigate('/schedule-list')}
                                    title="View Schedule List"
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        color: '#2e3192',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f3f2ef';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <FontAwesomeIcon icon={faLineChart} style={{ fontSize: '20px' }} />
                                    <span style={{ fontSize: '11px', fontWeight: '500' }}>Schedule</span>
                                </button>
                                
                                <button
                                    onClick={() => navigate('/viewallpostedposts')}
                                    title="View Published Posts"
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        color: '#2e3192',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f3f2ef';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <FontAwesomeIcon icon={faNewspaper} style={{ fontSize: '20px' }} />
                                    <span style={{ fontSize: '11px', fontWeight: '500' }}>Published</span>
                                </button>
                            </div>
                        </div>
                        <hr />
                        {loading ? <div className="spinner"></div> : <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                    <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}>Days of the Week:</label>
                                        <Select
                                            // isMulti
                                            options={daysOfWeek}
                                            value={selectedDays}
                                            onChange={handleSelectChange}
                                        />
                                    </div>
                                    {/* Email field hidden as requested */}
                                    {/* <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}>Email:</label>
                                        <input
                                            type="email"
                                            // disabled
                                            defaultValue={LinkedinEmail}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div> */}
                                    <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}> Start Date:</label>
                                        <input
                                            type="date"
                                            value={date}
                                            onChange={(e) => {
                                                setDate(e.target.value);
                                                setError(''); // Clear error when start date changes
                                            }}
                                        />
                                    </div>
						<div>
							<label style={{ textAlign: 'left', marginTop: '15px' }}>Prompts:</label>
							<Select
                                            // isMulti
                                            options={options} // Options populated by API call
                                            value={selectedValues}
                                            onChange={handleSelectCategory} // Handle changes to selected values
                                        />
							<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<button
									type="button"
									title="Add prompt"
									className="btn btn-link"
									style={{
										padding: '4px 8px',
										textDecoration: 'none',
										fontSize: 24,
										fontWeight: 'bold',
										color: '#000',
										cursor: 'pointer',
										background: '#f0f0f0',
										border: '1px solid #ddd',
										borderRadius: '4px',
										lineHeight: 1,
										minWidth: '32px',
										height: '32px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										transition: 'all 0.2s ease',
										marginTop: 6
									}}
									onMouseEnter={(e) => {
										e.target.style.background = '#e0e0e0';
										e.target.style.borderColor = '#2e3192';
										e.target.style.color = '#2e3192';
									}}
									onMouseLeave={(e) => {
										e.target.style.background = '#f0f0f0';
										e.target.style.borderColor = '#ddd';
										e.target.style.color = '#000';
									}}
									onClick={() => setShowAddPromptModal(true)}
								>
									+
								</button>
							</div>
                                    </div>

                                </div>
                                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                    <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}>Time:</label>
                                        <input
                                            type="time"
                                            value={time}
                                            onChange={(e) => {
                                                setTime(e.target.value);
                                                setError(''); // Clear error when time changes
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}>End Date:</label>
                                        <input
                                            type="date"
                                            value={endDate}
                                            onChange={(e) => {
                                                setEndDate(e.target.value);
                                                setError(''); // Clear error when end date changes
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ textAlign: 'left', marginTop: '15px' }}>Timezone:</label>
                                        <TimezoneSelect
                                            value={selectedTimezone}
                                            onChange={setSelectedTimezone}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Platform Selection - Only show for Page accounts */}
                            {!platformsLoading && enabledPlatforms.length > 0 && (localStorage.getItem('AccountType') !== 'User' && localStorage.getItem('AccountType') !== 'user') && (
                                <div style={{
                                    marginTop: '20px',
                                    padding: '16px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e0dfdc',
                                    position: 'relative',
                                    zIndex: 0,
                                    isolation: 'isolate'
                                }}>
                                    <label style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#2e3192',
                                        marginBottom: '12px',
                                        display: 'block'
                                    }}>
                                        Select Platforms to Schedule To:
                                    </label>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '16px',
                                        alignItems: 'center'
                                    }}>
                                        {enabledPlatforms.map((platform) => {
                                            const platformIcons = {
                                                linkedin: <FaLinkedin style={{ color: '#0077b5', fontSize: '24px' }} />,
                                                facebook: <FaFacebook style={{ color: '#1877F2', fontSize: '24px' }} />,
                                                instagram: <FaInstagram style={{ color: '#E4405F', fontSize: '24px' }} />
                                            };
                                            const isSelected = selectedPlatforms.includes(platform.code);
                                            
                                            return (
                                                <label
                                                    key={platform.code}
                                                    title={platform.name}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        padding: '10px',
                                                        borderRadius: '8px',
                                                        backgroundColor: isSelected ? '#e8f0fe' : 'white',
                                                        border: `2px solid ${isSelected ? '#2e3192' : '#e0dfdc'}`,
                                                        transition: 'all 0.2s ease',
                                                        userSelect: 'none',
                                                        minWidth: '48px',
                                                        height: '48px',
                                                        position: 'relative'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = isSelected ? '#d0e7ff' : '#f0f0f0';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = isSelected ? '#e8f0fe' : 'white';
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        onChange={() => handlePlatformToggle(platform.code)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '4px',
                                                            right: '4px',
                                                            width: '16px',
                                                            height: '16px',
                                                            cursor: 'pointer',
                                                            accentColor: '#2e3192',
                                                            zIndex: 0
                                                        }}
                                                    />
                                                    <span style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        {platformIcons[platform.code] || <FaLinkedin style={{ fontSize: '24px' }} />}
                                                    </span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                    <small style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: '8px',
                                        color: '#666',
                                        fontSize: '12px',
                                        gap: '8px'
                                    }}>
                                        Selected: {selectedPlatforms.length > 0 
                                            ? selectedPlatforms.map((code, index) => {
                                                const platformIcons = {
                                                    linkedin: <FaLinkedin key={index} style={{ color: '#0077b5', fontSize: '16px' }} />,
                                                    facebook: <FaFacebook key={index} style={{ color: '#1877F2', fontSize: '16px' }} />,
                                                    instagram: <FaInstagram key={index} style={{ color: '#E4405F', fontSize: '16px' }} />
                                                };
                                                return platformIcons[code] || null;
                                            })
                                            : 'None'}
                                    </small>
                                </div>
                            )}

                            <button 
                                type="submit" 
                                disabled={loading || (!platformsLoading && selectedPlatforms.length === 0)} 
                                style={{ 
                                    backgroundColor: (loading || (!platformsLoading && selectedPlatforms.length === 0)) ? "#6c757d" : "#2e3192", 
                                    borderRadius: 8, 
                                    marginTop: 20, 
                                    opacity: (loading || (!platformsLoading && selectedPlatforms.length === 0)) ? 0.7 : 1, 
                                    cursor: (loading || (!platformsLoading && selectedPlatforms.length === 0)) ? 'not-allowed' : 'pointer' 
                                }}
                            >
                                {loading 
                                    ? (platformsLoading ? 'Loading...' : `Scheduling${selectedPlatforms.length > 0 ? ` to ${selectedPlatforms.map(code => {
                                        const platform = enabledPlatforms.find(p => p.code === code);
                                        return platform ? platform.name : code;
                                    }).join(' & ')}` : '...'}`)
                                    : (platformsLoading ? 'Loading...' : selectedPlatforms.length > 0 
                                        ? formatPlatformNamesForButton(selectedPlatforms.map(code => {
                                            const platform = enabledPlatforms.find(p => p.code === code);
                                            return platform || { name: code, code: code };
                                        })).replace('Post to ', 'Schedule to ')
                                        : 'Select platforms to schedule')
                                }
                            </button>
                        </form>
                        }

                        {/* {message && <p>{message}</p>} */}
						{error && <p style={{ color: 'red' }}>{error}</p>}

						{/* Add Prompt Modal */}
						{showAddPromptModal && (
							<div className="modal" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
								<div className="modal-dialog">
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title">Add Post Prompt</h5>
											<button type="button" className="btn-close" onClick={() => setShowAddPromptModal(false)} />
										</div>
										<div className="modal-body">
											<textarea
												value={newPromptText}
												onChange={(e) => setNewPromptText(e.target.value)}
												className="form-control"
												placeholder="Enter your prompt"
												rows={4}
											/>
										</div>
										<div className="modal-footer">
											<button type="button" className="btn btn-secondary" onClick={() => setShowAddPromptModal(false)}>Cancel</button>
											<button type="button" className="btn btn-primary" onClick={handleSavePrompt} disabled={savingPrompt}>
												{savingPrompt ? 'Saving...' : 'Save Prompt'}
											</button>
										</div>
									</div>
								</div>
							</div>
						)}
                    </div>
                </SideNav>
            </div>
        </div>
        
    );
};

export default ScheduleForm;
